import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import GlobalDataCollectionSettings from './GlobalDataCollectionSettings';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  isLoading: state.trackerSettings.global.isLoading,
  failed: state.trackerSettings.global.failed,
});

export const ConnectedGlobalDataCollectionSettings = connect(
  mapStateToProps, null,
)(GlobalDataCollectionSettings);

export default withTranslation(['administration'])(ConnectedGlobalDataCollectionSettings as any);
